<template>
    <div>
        <section class="region region-product" id="product-section">
            <article class="article article-left item product-page">

                <div class="article-media item__media">

                    <badges :product="product"></badges>

                    <div id="product-images" class="product-images-wrapper js-slick-productimages">
                        <div v-if="product.video && !isPlusSize" class="product-images-item">
                            <video id="product-show-video" playsinline autoplay loop muted>
                                <source :src="product.video.url" type="video/mp4">
                                Your browser does not support the video tag.
                            </video>
                        </div>

                        <div class="product-images-item" v-for="(image, index) in productImages">
                            <img
                                 :src="image" :alt="index === 0 ? 'metatitle' : ''"
                                 :title="index === 0 ? product.name : ''" class="js-magnifier"
                                 :data-image-index="index"
                                 @click="$refs.zoomModalCarousel.goToSlide(index)"/>
                        </div>

                        <div v-if="product.customVideoUrl && !isPlusSize" class="product-images-item">
                            <video id="product-show-custom-video"
                                   :style="getCustomVideoStyle()"
                                   playsinline autoplay loop muted
                            >
                                <source :src="product.customVideoUrl" type="video/mp4">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
                <div class="article-header item__description">
                    <div class="position-sticky">
                        <h1 class="article-title article-title-mod-1">
                            {{ product.name }}
                        </h1>

                        <p class="article-price">
                            <span>
                                <span :class="{promo: product.isDiscounted }">
                                    {{ product.price | currency(currencyFormat(product.currency)) }}
                                </span>
                                <del v-if="product.isDiscounted">
                                    {{ product.originalPrice | currency(currencyFormat(product.currency)) }}
                                </del>
                            </span>
                        </p>

                        <variants-picker
                            :product.sync="product"
                            :variants="variants"
                        ></variants-picker>

                        <size-selector
                            :sizes="product.sizes"
                            :selectedSize.sync="selectedSize"
                        ></size-selector>

                        <div v-if="product.fashionModel && showProductFashionText" class="small" style="font-size: 65%">
                            {{
                                __('A főképen látható modell magassága :height cm. A termék mérete: :size.', {
                                    height: product.fashionModel.height,
                                    size: product.fashionModel.size
                                })
                            }}
                        </div>

                        <div class="mt-2 d-flex align-items-center justify-content-between">
                            <a href="javascript:void(0)"
                               v-if="product.sizeTable"
                               data-remodal-target="modal-chart" class="reference"
                               style="font-size: unset; margin-left: 2em;" :title="__('Mérettáblázat')"
                            >
                                {{ __('Mérettáblázat') }}
                            </a>

                            <a v-if="product.sizes.filter((size) => size.quantity <= 0).length > 0"
                               href="#"
                               class="reference"
                               @click="showOutOfStockNotificationModal = !showOutOfStockNotificationModal"
                               style="font-size: unset; margin-left: 2em; margin-right: 2em;"
                            >
                                {{ __('Elfogyott a méret?') }}
                            </a>
                        </div>

                        <div class="article-toolbar my-2">
                            <add-to-cart
                                :id='{ type: product.type, identifier: selectedSize ? selectedSize.product_id : product.id }'
                                :data-toggle="selectedSize ? null : 'tooltip'"
                                data-placement="top"
                                title="Tooltip on top"
                                :disabled="product.sizes.length > 0 ? ! selectedSize : false">
                                {{ __('Kosárba') }}
                            </add-to-cart>


                            <add-to-wishlist-collection
                                :item='{ type: product.type, identifier: product.id }'
                                :exist-in-the-list-collection='product.existInTheWishlistCollection'
                                list-collection="favourites"
                                :added-message="__('Product added to your wishlist!')"
                                :removed-message="__('Product removed from your wishlist.')"
                            />

                        </div>

                        <a v-if="stockModalIsEnabled"
                           href="#"
                           class="mt-5 reference"
                           @click="showStockModal = !showStockModal"
                           style="font-size: unset"
                        >
                            {{ __('Melyik üzletben kapható ez a termék?') }}
                        </a>


                        <div class="tablist" style="margin-top: 2.5em;">
                            <div class="tablist-accordion-item">
                                <h3 class="tablist__tab tablist__tab--active"
                                    data-controls="tabpanel1">
                                    {{ __('Leírás') }}
                                </h3>
                                <div class="tablist__tabpanel tablist__tabpanel--active" data-id="tabpanel1">
                                    <p v-html="product.description"></p>

                                    <p class="product-number">
                                        {{ __('Cikkszám') }}: {{ product.basicCode }}
                                        <input type="text" id="productBasicCode" :value="product.basicCode" style="display: none;">
                                        <button
                                            class="ml-2"
                                            style="border-radius: 5px;"
                                            @click="copyToClipboard('productBasicCode', $event.target)"
                                        >
                                            <i class="fa fa-copy"></i>
                                        </button>
                                    </p>
                                    <p>{{ product.material }}</p>
                                </div>
                            </div>
                            <div class="tablist-accordion-item">
                                <h3 class="tablist__tab"
                                    data-controls="tabpanel3">
                                    {{ __('Szállítás') }}
                                </h3>
                                <div class="tablist__tabpanel" data-id="tabpanel3" style="display: none;">
                                    <p v-html="shippingDescription.content"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.article-header -->
            </article>
            <!-- /.article -->


            <!-- /#modal-stock -->

        </section>

        <related-products
            :title="__('Ezeket is vedd meg hozzá!')"
            :url="relatedProductsUrl"
            :product="product"
            type="recommended"
        ></related-products>

        <related-products
            :title="__('Hasonló termékek')"
            :url="relatedProductsUrl"
            :product="product"
            type="similar"
        ></related-products>

        <stock-modal
            :show-modal.sync="showStockModal"
            :product.sync="product"
            :variants="variants"
            :size.sync="selectedSize"
        ></stock-modal>

        <size-table
            :product="product"
        ></size-table>

        <OutOfStockNotificationModal
            :show-modal.sync="showOutOfStockNotificationModal"
            :product="product"
            :user-email="userEmail"
        ></OutOfStockNotificationModal>

        <div id="modal-zoom" class="remodal" data-remodal-id="modal-zoom" data-remodal-options="hashTracking: false">
            <button data-remodal-action="close" class="remodal-close"></button>
        </div> <!-- /#modal-stock -->

        <div class="budmil-zoom-modal">
            <button class="remodal-close budmil-zoom-modal-close"></button>


            <article class="item">
                <vueper-slides :dragging-distance="50" :fixed-height="false" :arrows="true" :bullets="false"
                               ref="zoomModalCarousel">
                    <vueper-slide
                        v-for="(slide, i) in productImages"
                        :key="i"
                        :content="'<img src=' + slide + ' />'"
                    />
                </vueper-slides>
                <!-- <div class="slick-slider js-slick-zoom-for item__images">


                    <div
                        v-for="(image, index ) in product.images"
                        class="slick-slide item__image">
                        <img :src="image" :alt="product.name"  style="zoom: 185%"/>
                    </div>
                </div> -->
            </article>
        </div>
    </div>
</template>

<script>
import ResponsiveImage from '../mediaLibrary/ResponsiveImage';
import SizeSelector from './partials/SizeSelector';
import StockModal from './partials/StockModal';
import VariantsPicker from './partials/VariantsPicker';
import SizeTable from './partials/SizeTable';
import Badges from './partials/Badges';
import currencyFormatter from '../mixins/currencyFormatter';
import {VueperSlide, VueperSlides} from 'vueperslides';
import OutOfStockNotificationModal from './partials/OutOfStockNotificationModal'

export default {
    name: 'Product',
    mixins: [currencyFormatter],
    components: {
        Badges,
        SizeTable,
        VariantsPicker,
        StockModal,
        SizeSelector,
        ResponsiveImage,
        VueperSlides,
        VueperSlide,
        OutOfStockNotificationModal,
    },

    props: {
        selectedProduct: {
            type: Object,
            required: true,
        },

        variants: {
            type: Array
        },

        shippingDescription: {
            type: Object
        },

        slides: {
            type: Array,
        },

        stockModalIsEnabled: {
            type: Boolean,
            default: () => false,
        },

        isPlusSize: {
            type: Boolean,
            default: () => false,
        },

        relatedProductsUrl: {
            type: String,
            required: true
        },

        userEmail: {
            type: String,
            default: () => null,
        },
    },

    data() {
        return {
            product: this.selectedProduct,
            selectedSize: null,
            showStockModal: false,
            playVideo: false,
            hasPlusSizeProduct: false,
            showProductFashionText: true,
            showOutOfStockNotificationModal: false,
        }
    },

    computed: {
        productImages() {
            if (this.isPlusSize && !this.selectedSize) {
                const plusSize = this.product.sizes.find(size => size.isPlusSize);

                if (plusSize && plusSize.plusSizeImages.length > 0) {
                    return plusSize.plusSizeImages
                }
            }

            if (this.selectedSize && this.selectedSize.isPlusSize && this.selectedSize.plusSizeImages.length > 0) {
                return this.selectedSize.plusSizeImages
            }

            return this.product.images;
        },

        plusSizeVideoImage() {
            if (this.isPlusSize && !this.selectedSize) {
                const plusSize = this.product.sizes.find(size => size.isPlusSize);

                if (plusSize && plusSize.plusSizeImages.length > 0) {
                    return true
                }
            }

            if (this.selectedSize && this.selectedSize.isPlusSize && this.selectedSize.plusSizeImages.length > 0) {
                return true
            }

            return false;
        }
    },

    watch: {
        product() {
            this.selectedSize = null
            this.setProductToMinimumPrice()
            window.history.replaceState({id: this.product.id}, this.product.url, this.product.url)

            if (this.product.video) {
                document.getElementById('product-show-video').load()
            }

            if (this.product.customVideoUrl) {
                document.getElementById('product-show-custom-video').load()
            }
        },

        selectedSize() {
            if (!this.selectedSize) return

            this.product.price = this.selectedSize.price
            this.product.originalPrice = this.selectedSize.originalPrice
            this.setShowProductFashionText()
        },
    },

    mounted() {
        this.initPlusSizeProduct()
    },

    methods: {
        initPlusSizeProduct() {
            const plusSizeProduct = this.plusSizeProduct()

            this.hasPlusSizeProduct = typeof plusSizeProduct !== 'undefined'

            if (this.isPlusSize) {
                this.selectedSize = plusSizeProduct;
                this.showProductFashionText = false;
            }
        },

        plusSizeProduct() {
            return this.product.sizes.find(size => size.isPlusSize);
        },

        isShowVideo(index) {
            return !this.isPlusSize && !this.hasPlusSizeProduct && index === 1 && this.product.video !== null
                || this.isShowPlusSizeImage(index)
        },

        isShowPlusSizeImage(index) {
            return ! this.isPlusSize && this.hasPlusSizeProduct && index === 2 && this.product.video !== null
        },

        setProductToMinimumPrice()
        {
            const minimumProduct = _.min(this.product.sizes, 'price')

            if (minimumProduct) {
                this.product.price = minimumProduct.price
                this.product.originalPrice = minimumProduct.originalPrice
            }
        },

        setShowProductFashionText() {
            this.showProductFashionText = !this.selectedSize.isPlusSize
        },

        copyToClipboard(elementId, button) {
            var element = document.getElementById(elementId);
            element.select();
            element.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(element.value);

            if (button.tagName === 'I') {
                button = button.parentElement;
            }

            button.classList.add('btn-success');

            setTimeout(function() {
                button.classList.remove('btn-success');
            }, 3000);
        },

        getCustomVideoStyle() {
            return (this.productImages.length + (this.product.video ? 1 : 0) + (this.product.customVideoUrl ? 1 : 0)) % 2 !== 0
                ? 'position: relative; margin: auto;'
                : ''
        },
    }
}
</script>

<style>
</style>
